export default {
  LOCATIONS: [
    {
      value: "remote",
      text: "Remote",
    },
    {
      value: "on-site",
      text: "On-site",
    },
    {
      value: "hybrid",
      text: "Hybrid",
    },
  ],
  STATUS: [
    {
      value: "active",
      text: "Active",
    },
    {
      value: "draft",
      text: "Draft",
    },
    {
      value: "expired",
      text: "Expired",
    },
    {
      value: "closed",
      text: "Closed",
    },
  ],
  PREFERRED_SKILLS: [
    {
      value: "business-acumen",
      label: "Business Acumen",
      children: [
        {
          value: "agility-and-innovation",
          label: "Agility and Innovation",
        },
        {
          value: "business-acumen",
          label: "Business Acumen",
        },
        {
          value: "design-thinking",
          label: "Design Thinking",
        },
        {
          value: "financial-acumen",
          label: "Financial Acumen",
        },
        {
          value: "legal-acumen",
          label: "Legal Acumen",
        },
        {
          value: "measuring-hr-effectiveness",
          label: "Measuring HR Effectiveness",
        },
        {
          value: "organizational-agility",
          label: "Organizational Agility",
        },
        {
          value: "project-and-resource-management",
          label: "Project and Resource Management",
        },
        {
          value: "problem-solving-and-analytical-skills",
          label: "Problem Solving & Analytical Skills",
        },
      ],
    },
    {
      value: "hr-human-skills",
      label: "HR Human Skills",
      children: [
        {
          value: "building-networks-and-relationships",
          label: "Building Networks and Relationships",
        },
        {
          value: "coaching-counseling",
          label: "Coaching/Counseling",
        },
        {
          value: "change-management",
          label: "Change Management",
        },
        {
          value: "communication-and-influence",
          label: "Communication and Influence",
        },
        {
          value: "corporate-culture",
          label: "Corporate Culture",
        },
        {
          value: "driving-change",
          label: "Driving Change",
        },
        {
          value: "negotiation",
          label: "Negotiation",
        },
        {
          value: "people-analytics",
          label: "People Analytics",
        },
        {
          value: "team-facilitation",
          label: "Team Facilitation",
        },
        {
          value: "teamwork-and-collaboration",
          label: "Teamwork and Collaboration",
        },
      ]
    },
    {
      value: "hr-technical-skills",
      label: "HR Technical Skills",
      children: [
        {
          value: "brand-communication",
          label: "Brand Communication",
        },
        {
          value: "compensation-and-benefits-administration",
          label: "Compensation and Benefits Administration",
        },
        {
          value: "salary-review-and-payroll",
          label: "Salary Review and Payroll",
        },
        {
          value: "critical-and-strategic-thinking",
          label: "Critical and Strategic Thinking",
        },
        {
          value: "digital-acumen",
          label: "Digital Acumen",
        },
        {
          value: "diversity-equity-inclusion-and-belonging-strategies",
          label: "Diversity, equity, inclusion and belonging strategies.",
        },
        {
          value: "employee-experience-and-engagement",
          label: "Employee Experience and Engagement",
        },
        {
          value: "employee-and-labor-relations",
          label: "Employee & Labor Relations",
        },
        {
          value: "hr-technology-information-software-and-systems",
          label: "HR Technology, Information Software and Systems",
        },
        {
          value: "hr-strategy-design-and-execution",
          label: "HR Strategy Design and Exection",
        },
        {
          value: "people-analytics-and-reporting",
          label: "People Analytics and Reporting",
        },
        {
          value: "performance-management",
          label: "Performance Management",
        },
        {
          value: "onboarding",
          label: "Onboarding",
        },
        {
          value: "organizational-diagnosis-and-design",
          label: "Organizational Diagnosis & Design",
        },
        {
          value: "recruitment-hiring-and-onboarding",
          label: "Recruitment, hiring and onboarding",
        },
        {
          value: "wellness-and-well-being-strategy-design-and-execution",
          label: "Wellness and Well-Being strategy design and execution",
        },
      ]
    },
  ],
};
